export default {
	id: 'SIMPLE_WORKBOOK_SLEEP_14_99',
	providers: {
		paltaMap: {
			USD: 'simple_workbook_sleep_14_99_usd',
		},
		primer: 'prd_wNlD9jJ3l1Vc',
	},
	otp: {
		priceMap: {
			USD: 14.99,
		},
	},
}
